import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { getProfileImageRoute } from "@ponder-features/user/profile/profile-image-router";
import { Subscription } from "rxjs";

@Component({
    selector: "avatar",
    imports: [NgClass],
    templateUrl: "./avatar.component.html"
})
export class AvatarComponent {
    @Input({ required: true }) public username!: string;
    @Input() public small: boolean = false;

    public avatarUrl!: string;

    private avatarUpdatedSub!: Subscription;

    public constructor(private events: EventBroker) {
        this.avatarUpdatedSub = this.events.profile.profileAvatarUpdatedEvent.subscribe(() => {
            this.resetAvatarUrl();
        });
    }

    public ngOnDestroy(): void {
        this.avatarUpdatedSub?.unsubscribe();
    }

    public ngOnInit(): void {
        this.resetAvatarUrl();
    }

    private resetAvatarUrl(): void {
        this.avatarUrl = getProfileImageRoute(this.username);
    }
}